import styled from 'styled-components';

const Box = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  border: 1px solid #d6e4f2;
  border-radius: 8px;
  margin-top: 32px;
`;
const BoxHeader = styled.div`
  flex-direction: column;
  align-items: center;
  display: flex;
  justify-content: center;
  background: #d6e4f2;
  width: 100%;
  overflow: hidden;
  padding: 16px 0px;
  border-radius: 8px 8px 0px 0px;
`;
const BoxContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const BoxContentItem = styled.div`
  margin-bottom: 16px;
  background: #eff5fb;
  border-radius: 8px;
  width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  .title-container {
    flex: 1;
    border-right: 1px solid #21aae8;
    border-left: 1px solid #21aae8;
  }
  .title {
    margin-left: 32px;

    font-weight: 600;
  }
  .subTitle {
    margin-left: 32px;
    font-weight: 400;
    font-size: 14px;
  }
  .date {
    width: 100px;
  }
  .arrow {
    margin-left: 32px;
  }
`;
const BoxFooter = styled.div`
  border-radius: 0px 0px 8px 8px;
  background: white;
  padding: 16px;
  margin-bottom: 16px;
`;
const ArrowWrap = styled.div<{ color?: string }>`
  width: 36px;
  height: 36px;
  background-color: ${({ color }) => color};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DropdownWrap = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export default {
  Box,
  BoxHeader,
  BoxContent,
  BoxContentItem,
  BoxFooter,
  ArrowWrap,
  DropdownWrap,
};
